<div class="container two-step-verification-box mb-5">
    <div class="row pb-4">
        <div class="col-lg-2">
            <img src="/assets/images/logo-dark.png" width="180">
        </div>
        <!-- <div class="col-lg-10">
             <h3 class="font-bold text-center pt-1"><b>Two-Factor Authentication (2FA) Setup Guide</b></h3>
        </div> -->
    </div>
    <div class="text-center">
        <h3 class="font-bold text-center pt-1"><b>Two-Factor Authentication (2FA) Setup Guide</b></h3>
    </div>
    <div class="">
        <div class="pt-3">
            
            <p><b>Purpose:</b></p>
            <div class="ps-4 font-size-14">
                <p>This guide will help you securely set up 2FA using your mobile device for enhanced account security.</p>

            </div>
        </div>
        <div class="pt-3">
            <b>What You Need Before You Start</b>
            <div class="ps-4 pt-3 font-size-14">
                <p>- A smartphone with internet access.</p>
                <p>- An authenticator app (Microsoft Authenticator or Google Authenticator).</p>
                <p>- Access to your email or work account.</p>
            </div>
        </div>
        <h3 class="pt-3">Registering a new account</h3>
        <div class="pt-3">
            <h4><span class="number-box">1</span> Install the Authenticator App</h4>
            <div class="ps-5 font-size-14">
                <b>Option A: Microsoft Authenticator</b>
                <div class="ps-5 font-size-14">
                    <p>Open your phone's app store and search for Microsoft Authenticator</p>
                    <p>iOS:
                        <a
                            href="https://apps.apple.com/app/microsoft-authenticator/id983156458">https://apps.apple.com/app/microsoft-authenticator/id983156458</a>
                    </p>
                    <p>Android:
                        <a
                            href="https://play.google.com/store/apps/details?id=com.azure.authenticator">https://play.google.com/store/apps/details?id=com.azure.authenticator</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="pt-2 ps-5">
            <b>Option B: Google Authenticator</b>
            <div class="ps-5 font-size-14">
                <p>Search for Google Authenticator in your app store</p>
                <p>iOS:
                    <a
                        href="https://apps.apple.com/app/google-authenticator/id388497605">https://apps.apple.com/app/google-authenticator/id388497605</a>
                </p>
                <p>Android:
                    <a href="https://play.google.com/store/apps/details?">https://play.google.com/store/apps/details?</a>
                </p>
                <p>id=com.google.android.apps.authenticator2</p>
            </div>
        </div>
        <div class="pt-3">
            <h4><span class="number-box">2</span> Begin MFA Setup on Your Account</h4>
            <div class="ps-4 font-size-14">
                <p>1. Go to Login screen of Lendisoft web application.</p>
                <p>2. Enter your credentials, and you will see a QR code.</p>
            </div>
        </div>
        <div class="pt-3">
            <h4><span class="number-box">3</span> Scan the QR Code</h4>
            <div class="ps-4 font-size-14">
                <p>1. On your computer screen, you’ll see a QR Code.</p>
                <p>2. Open the Authenticator App → Tap '+' to add a new account.</p>
                <p>3. Choose 'Scan QR code'.</p>
                <p>4. Point your phone’s camera at the QR code.</p>
            </div>
        </div>
        <div class="pt-3">
            <h4><span class="number-box">4</span> Enter the Code</h4>
            <div class="ps-4 font-size-14">
                <p>1. Once the account is added, your authenticator app will generate a 6-digit code.</p>
                <p>2. Type this code into the Lendisoft web application when prompted.</p>
                <p>3. Click Verify or Submit.</p>
            </div>
        </div>
        <div class="pt-3">
            <h4>Success!</h4>
            <div class="ps-4 font-size-14">
                <p>You’ve successfully enabled Two-Factor Authentication. From now on, you’ll need both your password and
                    the 6-digit code from your app to sign in.</p>
            </div>
        </div>
        <hr/>
        <div class="pt-3">
            <h3>Re-registering an already registered account.</h3>
            <div class="ps-4 font-size-14 pt-3">
                <b>Contact your administrator </b>
                <p>To re-register your account, you must first contact your administrator. They will de-register your account from the Lendisoft Portal. Only after that can you proceed with the next steps.</p>
                <b>Remove the existing account</b>
                <p>In your authenticator app, find the account you want to re-register and remove it. </p>
                <b>Follow steps 2, 3, and 4</b>
                <p>Follow above registration step 2, 3, and 4 for registering again.</p>
            </div>
        </div>
    </div>
</div>